import styled from 'styled-components';
import { FONTS, SIZE, COLORS } from '@app/src/ui';
import { RadioInput } from '../RadioInput/RadioInput';

interface Props {
  active?: boolean;
}

export const Item = styled.li`
  font-family: ${FONTS.ROBOTO};
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 44px;
  width: 100%;
  cursor: pointer;
  outline: none;
  &:hover {
    background: aliceblue;
  }
  background: ${(props: Props) => props.active && 'aliceblue'};
  label {
    padding: 0 15px;
    width: 100%;
    justify-content: space-between;
  }
`;

export const Text = styled.p`
  width: 100%;
  text-align: left;
`;

export const SubText = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 11px;
  color: ${COLORS.GRAY_DARK};
`;

export const Content = styled.div`
  width: 86%;
  pointer-events: none;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: 100%;
  }
`;

export const Ubigeo = styled.span`
  font-size: 14px;
  color: ${COLORS.GRAY_DARK};
`;

export const RadioInputWrapper = styled(RadioInput)`
  min-height: 44px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    i {
      display: none;
    }
  }
`;
